import { Attachment } from '@capacitor/local-notifications';
import { Activity } from 'src/app/entities/Activity';
import { ActivityLog } from 'src/app/entities/ActivityLog';
import { EntityType } from 'src/app/entities/EntityType';
import { FieldActivity } from 'src/app/entities/FieldActivity';
import { FIPSState } from 'src/app/entities/FIPSState';
import { LaborCategory } from 'src/app/entities/LaborCategory';
import { NotableActivityOption } from 'src/app/entities/NotableActivityOption';
import { OdometerReading } from 'src/app/entities/OdometerReading';
import { Project } from 'src/app/entities/Project';
import { StatusLookup } from 'src/app/entities/StatusLookup';
import { StoreName } from 'src/app/entities/StoreName';
import { Task } from 'src/app/entities/Task';
import { Team } from 'src/app/entities/Team';
import { TeamUser } from 'src/app/entities/TeamUser';
import { TimeManagerProject } from 'src/app/entities/TimeManagerProject';
import { TimeManagerTeam } from 'src/app/entities/TimeManagerTeam';
import { TimeRecord } from 'src/app/entities/timeRecord';
import { TimeRecordStatus } from 'src/app/entities/TimeRecordStatus';
import { User } from 'src/app/entities/User';
import { UserFieldActivity } from 'src/app/entities/UserFieldActivity';
import { UserProject } from 'src/app/entities/UserProject';

export enum SyncResponseAttributes {
  StatusLookups = 'StatusLookups',
  EntityTypes = 'EntityTypes',
  FIPSStates = 'FipsStates',
  TimeRecordStatuses = 'TimeRecordStatuses',
  Activities = 'Activities',
  ActivityLogs = 'ActivityLogs',
  Attachments = 'Attachments',
  LaborCategories = 'LaborCategories',
  NotableActivity = 'NotableActivities',
  Projects = 'Projects',
  Tasks = 'Tasks',
  Team2Users = 'Team2Users',
  Teams = 'Teams',
  TimeManager2Projects = 'TimeManager2Projects',
  TimeManager2Teams = 'TimeManager2Teams',
  TimeRecords = 'TimeRecords',
  Users = 'Users',
  FieldActivities = 'FieldActivities',
  Users2FieldActivities = 'Users2FieldActivities',
  Users2Projects = 'Users2Projects',
  OdometerReading = 'OdometerReadings',
}

export interface SyncResponse {
  [SyncResponseAttributes.StatusLookups]: StatusLookup[];
  [SyncResponseAttributes.EntityTypes]: EntityType[];
  [SyncResponseAttributes.FIPSStates]: FIPSState[];
  [SyncResponseAttributes.TimeRecordStatuses]: TimeRecordStatus[];
  [SyncResponseAttributes.Activities]: Activity[];
  [SyncResponseAttributes.ActivityLogs]: ActivityLog[];
  [SyncResponseAttributes.Attachments]: Attachment[];
  [SyncResponseAttributes.LaborCategories]: LaborCategory[];
  [SyncResponseAttributes.NotableActivity]: NotableActivityOption[];
  [SyncResponseAttributes.Projects]: Project[];
  [SyncResponseAttributes.Tasks]: Task[];
  [SyncResponseAttributes.Team2Users]: TeamUser[];
  [SyncResponseAttributes.Teams]: Team[];
  [SyncResponseAttributes.TimeManager2Projects]: TimeManagerProject[];
  [SyncResponseAttributes.TimeManager2Teams]: TimeManagerTeam[];
  [SyncResponseAttributes.TimeRecords]: TimeRecord[];
  [SyncResponseAttributes.Users]: User[];
  [SyncResponseAttributes.FieldActivities]: FieldActivity[];
  [SyncResponseAttributes.Users2FieldActivities]: UserFieldActivity[];
  [SyncResponseAttributes.Users2Projects]: UserProject[];
  [SyncResponseAttributes.OdometerReading]: OdometerReading[];
}

export const SyncResponseStoreNamesMap = {
  [SyncResponseAttributes.StatusLookups]: StoreName.StatusLookup,
  [SyncResponseAttributes.EntityTypes]: StoreName.EntityType,
  [SyncResponseAttributes.FIPSStates]: StoreName.FIPSState,
  [SyncResponseAttributes.TimeRecordStatuses]: StoreName.TimeRecordStatus,
  [SyncResponseAttributes.Activities]: StoreName.Activity,
  [SyncResponseAttributes.ActivityLogs]: StoreName.ActivityLog,
  [SyncResponseAttributes.Attachments]: StoreName.Attachment,
  [SyncResponseAttributes.LaborCategories]: StoreName.LaborCategory,
  [SyncResponseAttributes.NotableActivity]: StoreName.NotableActivityOption,
  [SyncResponseAttributes.Projects]: StoreName.Project,
  [SyncResponseAttributes.Tasks]: StoreName.Task,
  [SyncResponseAttributes.Team2Users]: StoreName.Team2User,
  [SyncResponseAttributes.Teams]: StoreName.Team,
  [SyncResponseAttributes.TimeManager2Projects]: StoreName.TimeManager2Project,
  [SyncResponseAttributes.TimeManager2Teams]: StoreName.TimeManager2Team,
  [SyncResponseAttributes.TimeRecords]: StoreName.TimeRecord,
  [SyncResponseAttributes.Users]: StoreName.User,
  [SyncResponseAttributes.FieldActivities]: StoreName.FieldActivity,
  [SyncResponseAttributes.Users2FieldActivities]: StoreName.Users2FieldActivity,
  [SyncResponseAttributes.Users2Projects]: StoreName.Users2Project,
  [SyncResponseAttributes.OdometerReading]: StoreName.OdometerReading,
};

